import FalconComponentCard from "components/common/FalconComponentCard";

import { useSelector } from "react-redux";
import PatientInfoSection from "./PatientInfoSection";

const EligibilityResponsePatient = () => {
  const { eligibilityCheckData } = useSelector(
    (state) => state.eligibilityCheck
  );

  if (
    !eligibilityCheckData?.patient &&
    !eligibilityCheckData?.beneficiary_patient
  ) {
    return null;
  }

  return (
    <FalconComponentCard className="mb-4 ml-3">
      <FalconComponentCard.Body>
        {eligibilityCheckData?.patient && (
          <PatientInfoSection
            patient={eligibilityCheckData?.patient}
            title="Patient Information"
            showImage={true}
          />
        )}
        {eligibilityCheckData?.beneficiary_patient?.patient_firstname && (
          <PatientInfoSection
            patient={
              eligibilityCheckData?.beneficiary_patient?.patient_firstname
            }
            title="Beneficiary Information"
          />
        )}
      </FalconComponentCard.Body>
    </FalconComponentCard>
  );
};

export default EligibilityResponsePatient;
